import React from "react";
import { useTranslation } from "react-i18next";

const FEATURE_LABEL = {
  reports: "Reports",
  marketing: "Marketing",
  po: "Purchase Orders",
};

// Vendor Feature Lock (ADO #1597) — rendered by FeatureGuard in place of a locked
// route. Inherits Layout from PrivateRoute, same convention as PageNotAccess.
const FeatureLocked = ({ feature }) => {
  const { t } = useTranslation();
  const label = FEATURE_LABEL[feature] || feature;
  return (
    <div className="feature-locked">
      <h2>{t(`${label} is a premium feature`)}</h2>
      <p>
        {t(
          "This section is available on a paid subscription. Contact our support team to upgrade and unlock access."
        )}
      </p>
      <a
        className="primary-btn"
        href={`mailto:support@gemfind.com?subject=${encodeURIComponent(
          `Subscribe to ${label}`
        )}`}
      >
        {t("Contact Support to Subscribe")}
      </a>
    </div>
  );
};

export default FeatureLocked;
